module.exports = __webpack_public_path__ + "static/img/plague_maiden.109de43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/plague_maiden.png
// module id = WnTr
// module chunks = 0